module.exports = __webpack_public_path__ + "static/media/eclass.95ac9e94.svg";